import { render, staticRenderFns } from "./DefaultDataFormView.vue?vue&type=template&id=7d48494a&"
import script from "./DefaultDataFormView.vue?vue&type=script&lang=js&"
export * from "./DefaultDataFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports